@reference "@glow/tailwind-config/reference.css";

.button {
  @apply rounded-sm;
  @apply bg-white;
  @apply w-full;
  @apply h-full;
}
.size-md {
  @apply w-12;
  @apply h-12;
}
.size-sm {
  @apply w-8;
  @apply h-8;
}

.size-xs {
  @apply w-6;
  @apply h-6;
}
.button:hover {
  @apply bg-gray-100;
}
.button[aria-expanded="true"],
.buttonSelected {
  @apply border;
  @apply border-solid;
  @apply border-primary-500;
  @apply bg-primary-100;
}

.container {
  @apply bg-white;
  @apply flex;
  @apply items-center;
  @apply justify-center;
}

.stickyRight {
  @apply sticky;
  @apply right-0;
}

[data-selected="true"] .button,
.isSelected {
  @apply bg-primary-100;
}
